<div class="inner-content">
    <app-old-system-iframe
        [hidden]="!headlineService.showIframeInspector"
        (show)="headlineService.showIframeInspector = $event"
        src="administration/Inspector"
        key="check_hippo"></app-old-system-iframe>

    @if (!hasPageAccess) {
        <div
            *ngIf="!headlineService.showIframeInspector"
            class="h-full">
            <app-no-page-access></app-no-page-access>
        </div>
    } @else {
        <div
            *ngIf="!headlineService.showIframeInspector && data"
            class="p-4">
            <mat-card class="w-full border border-[#8CAACD] bg-[#E6F0FF]">
                <mat-card-content>
                    <div class="flex gap-2 justify-center items-center">
                        <div>Last check:</div>
                        <div
                            class="cursor-pointer font-semibold text-lg"
                            (click)="setLastDayTimestamp()">
                            {{
                                date === null
                                    ? data.date
                                    : data.date.slice(0, -9)
                            }}
                        </div>
                        <button
                            mat-raised-button
                            *ngIf="date"
                            (click)="resetTimestamp()">
                            Reset
                        </button>
                    </div></mat-card-content
                ></mat-card
            >
            <mat-card class="w-full border mt-4 border-[#8CAACD] bg-[#E6F0FF]">
                <mat-card-content>
                    <div class="w-fit">
                        <table>
                            <tr>
                                <td
                                    class="!pt-4 font-bold"
                                    colspan="2">
                                    Log files
                                </td>
                            </tr>
                            <tr>
                                <td
                                    class="!p-0"
                                    colspan="2">
                                    <hr class="m-0 p-0 border-[#8CAACD]" />
                                </td>
                            </tr>

                            <tr>
                                <td>common log:</td>
                                <td>
                                    <img
                                        [src]="
                                            environment.apiURL +
                                            '/img/common/' +
                                            getLogsImage(
                                                data.logs.common.file_status
                                            ) +
                                            '_round_16.png'
                                        "
                                        (click)="openLogFileWindow('common')"
                                        class="cursor-pointer" />
                                </td>
                            </tr>
                            <tr>
                                <td>hippodata log:</td>
                                <td>
                                    <img
                                        [src]="
                                            environment.apiURL +
                                            '/img/common/' +
                                            getLogsImage(
                                                data.logs.database.hd
                                                    .file_status
                                            ) +
                                            '_round_16.png'
                                        "
                                        (click)="openLogFileWindow('hd')"
                                        class="cursor-pointer" />
                                </td>
                            </tr>
                            <tr>
                                <td>hippodata central log:</td>
                                <td>
                                    <img
                                        [src]="
                                            environment.apiURL +
                                            '/img/common/' +
                                            getLogsImage(
                                                data.logs.database.hd_central
                                                    .file_status
                                            ) +
                                            '_round_16.png'
                                        "
                                        (click)="openLogFileWindow('hdc')"
                                        class="cursor-pointer" />
                                </td>
                            </tr>
                            <tr>
                                <td>hippodata store log:</td>
                                <td>
                                    <img
                                        [src]="
                                            environment.apiURL +
                                            '/img/common/' +
                                            getLogsImage(
                                                data.logs.database.hd_store
                                                    .file_status
                                            ) +
                                            '_round_16.png'
                                        "
                                        (click)="openLogFileWindow('hds')"
                                        class="cursor-pointer" />
                                </td>
                            </tr>
                            <tr>
                                <td
                                    class="pt-4 font-bold"
                                    colspan="2">
                                    Databases
                                </td>
                            </tr>
                            <tr>
                                <td
                                    class="!p-0"
                                    colspan="2">
                                    <hr class="m-0 p-0 border-[#8CAACD]" />
                                </td>
                            </tr>
                            <tr>
                                <td>hippodata central:</td>
                                <td>
                                    <img
                                        [src]="
                                            environment.apiURL +
                                            '/img/common/' +
                                            getLogsImage(
                                                data.database.hd_central.status
                                            ) +
                                            '_round_16.png'
                                        " />
                                </td>
                            </tr>
                            <tr>
                                <td>hippodata:</td>
                                <td>
                                    <img
                                        [src]="
                                            environment.apiURL +
                                            '/img/common/' +
                                            getLogsImage(
                                                data.database.hd.status
                                            ) +
                                            '_round_16.png'
                                        " />
                                </td>
                            </tr>
                            <tr>
                                <td>hippodata logistics:</td>
                                <td>
                                    <img
                                        [src]="
                                            environment.apiURL +
                                            '/img/common/' +
                                            getLogsImage(
                                                data.database.hd_store.status
                                            ) +
                                            '_round_16.png'
                                        " />
                                </td>
                            </tr>
                            <tr>
                                <td>hippo Administration:</td>
                                <td>
                                    <img
                                        [src]="
                                            environment.apiURL +
                                            '/img/common/' +
                                            getLogsImage(
                                                data.database.hd_base.status
                                            ) +
                                            '_round_16.png'
                                        " />
                                </td>
                            </tr>
                            <tr>
                                <td
                                    class="pt-4 font-bold"
                                    colspan="2">
                                    Jobs
                                </td>
                            </tr>
                            <tr>
                                <td
                                    class="!p-0"
                                    colspan="2">
                                    <hr class="m-0 p-0 border-[#8CAACD]" />
                                </td>
                            </tr>
                            <tr>
                                <td>invoice check:</td>
                                <td>
                                    <img
                                        [src]="
                                            environment.apiURL +
                                            '/img/common/' +
                                            getInvoiceCheckImage(
                                                data.jobs.invoice_check
                                                    .file_status
                                            ) +
                                            '_round_16.png'
                                        "
                                        (click)="requestInvoiceInformation()"
                                        class="cursor-pointer" />
                                </td>
                            </tr>
                        </table>
                    </div> </mat-card-content
            ></mat-card>
        </div>
    }
</div>
